export default __webpack_public_path__ + "static/media/banner-image-square-4.2b1b7ed9.jpg";